const contactContent = {
  mobile: {
    title: "Call Us",
    logo: "/images/icon/contact-us/mobile-app-icon.webp",
    content: "+63-2-8-6263222",
    qrCode: "/images/qr-code/phoneqr.webp",
  },
  viber: {
    title: "Viber Support",
    logo: "/images/icon/contact-us/viber-app-icon.webp",
    content: "+855-96-984-5632",
    qrCode: "/images/qr-code/viberqr.webp",
  },
  telegram: {
    title: "Telegram Channel",
    logo: "/images/icon/social-media/telegram.webp",
    content: "@FUNGAMINGHUB",
    qrCode: "/images/qr-code/tgqr-enhanced.webp",
  },
}

export default function ContactUs({ type, onClose }) {
  if (!type || !contactContent[type]) return null

  const { content, qrCode, logo } = contactContent[type]

  return (
    <div className="fgh-contact-us-container">
      <div className="fgh-contact-us-container--content">
        <div className="fgh-contact-logo">
          <img src={logo} alt="" />
        </div>

        <a href={qrCode} download={`FGH_${type.toUpperCase()}-QR-CODE.WEBP`}>
          <img className="fgh-qrcode" src={qrCode} alt="Contact Us QRCode" />
          <button className="contact-download">Download</button>
        </a>

        <p>{content}</p>

        <button className="contact-close" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  )
}
